import { SU } from '../../constants';
import FSA from '../FSA';

import suRequest, { apiFactory } from './requestFactory';
import { fetchContainer, fetchInformation } from './System';

interface ISystemPatches {
    nodeId?: string
}

interface IParams {
    containerIds: string[],
    start: Date,
    end: Date,
}

type IContainer = any;

async function fetchPatches(_requesterId: string, query, params: IParams, containers: IContainer[]): Promise<IContainer[]> {
    if (containers.length === 0) {
        return [];
    }

    const { customerId } = query.query;
    const mapContainers = new Map<string, IContainer>();

    containers.forEach(container => {
        // mapContainers.set(container.id, objectAssign({}, container, { patches: [] }));
        mapContainers.set(container.id, ({ ...container, patches: [] }));
    });

    query = {
        start: params.start.getTime(),
        end: params.end.getTime(),
        containerIds: containers.map(c => c.id),
        $fields: ['containerId', 'name', 'installedOn', 'description']
    };

    const patches: { containerId: string, name: string, installedOn: string, description: string }[] =
        await apiFactory.post(`smart-updates/${customerId}/findInstalled`, query);

    patches.forEach(patch => {
        const container = mapContainers.get(patch.containerId);
        if (container) { // to be on the safe side
            const { name, installedOn, description } = patch;
            container.patches.push({ name, installedOn, description });
        }
    });

    return Array.from(mapContainers.values());
}

function fetchCategories() {
    let query = {};
    return suRequest.get(`patch/categories`, query).then((categories) => {
        return categories;
    });
}

function listPatches(requesterId: string, query, params: IParams): Function {
    return dispatch => {
        dispatch(new FSA(SU.FETCH_PATCHES_REQUEST).addMeta({ requesterId }).data);
        return fetchContainer(requesterId, query).then(containers => {
            return fetchCategories().then(categories => {
                return fetchInformation(requesterId, query).then((information) => {
                    const containerList = containers.map((node) => {
                        node.suInformation = information[node.id];
                        if (node.suInformation.categories) {
                            node.suInformation.categories = node.suInformation.categories.map(cat => {
                                const category = categories.find(c => c.id == cat.id);
                                // Fallback to "id" if the category name is not found
                                cat.name = (category && category.name) ? category.name : cat.name = cat.id;
                                return cat;
                            });
                        }

                        return node;
                    });

                    fetchPatches(requesterId, query, params, containerList).then(result => {
                        return dispatch(new FSA(SU.FETCH_PATCHES_SUCCESS).addPayload(result).addMeta({ requesterId }).data);
                    }).catch(err => {
                        dispatch(new FSA(SU.FETCH_PATCHES_FAILURE).addError(err).addMeta({ requesterId }).data);
                        throw err;
                    });
                }).catch(err => {
                    dispatch(new FSA(SU.FETCH_PATCHES_FAILURE).addError(err).addMeta({ requesterId }).data);
                    throw err;
                });
            }).catch(err => {
                dispatch(new FSA(SU.FETCH_PATCHES_FAILURE).addError(err).addMeta({ requesterId }).data);
                throw err;
            });
        }).catch(err => {
            dispatch(new FSA(SU.FETCH_PATCHES_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}

export {
    ISystemPatches,
    fetchPatches,
    listPatches,
};


// WEBPACK FOOTER //
// ./src/actions/su/Patches.ts